import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FavoriteLocation, UserService } from '@uzurv/clara';

@Component({
  selector: 'app-favorite-location-list-item',
  templateUrl: './favorite-location-list-item.component.html',
  styleUrls: ['./favorite-location-list-item.component.css']
})
export class FavoriteLocationListItemComponent implements OnInit {
  @Input() favoriteLocation: FavoriteLocation = new FavoriteLocation();

  @Output() favoriteLocationSelectedHandler: EventEmitter<FavoriteLocation> = new EventEmitter<FavoriteLocation>();

  @Output() favoriteLocationDeleteHandler: EventEmitter<FavoriteLocation> = new EventEmitter<FavoriteLocation>();

  constructor(public userService: UserService) {}

  ngOnInit() {}

  selectFavoriteLocation() {
    this.favoriteLocationSelectedHandler.emit(this.favoriteLocation);
  }

  deleteFavoriteLocation() {
    this.favoriteLocationDeleteHandler.emit(this.favoriteLocation);
  }
}
